import React from 'react';

import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';

import {
    Grid,
    GridItem,
    Image,
} from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import styles from './CarrierImageGrid.scss';

function CarrierImageGrid(props) {
    const {
        t,
        images,
        namespace,
    } = props;

    if (!images.length) {
        return null;
    }

    return (
        <Grid>
            {images.map((image = {}, index) => {
                const {
                    src,
                    metadata = {},
                } = image;
                const {
                    alt: metaAlt,
                } = metadata;

                return (
                    <GridItem key={`${src}-${index}`} md={3} sm={4} xs={6}>
                        <LazyLoad height={168}>
                            <Image
                                alt={metaAlt || ''}
                                captionLicense={t(`${namespace}:stationImageLicense`)}
                                captionTitle={t(`${namespace}:stationImageCredit`)}
                                className={styles.image}
                                height={168}
                                loading="lazy"
                                metadata={metadata}
                                src={src}
                                width={224}
                            />
                        </LazyLoad>
                    </GridItem>
                );
            })}
        </Grid>
    );
}

CarrierImageGrid.propTypes = {
    images: PropTypes.arrayOf(PropTypes.shape({
        metadata: PropTypes.shape({
            alt: PropTypes.string,
            author: PropTypes.string,
            license: PropTypes.string,
        }),
        src: PropTypes.string.isRequired,
    })).isRequired,
};

export { CarrierImageGrid };
export default localize(CarrierImageGrid);
